/* Slide horizontal + arrastar com o dedo (telemovel) + revelar ao rolar.
   - Clique num link: a pagina sai a deslizar e navega (todos os navegadores).
   - No telemovel: arrastar na horizontal move a pagina a seguir o dedo;
     arrastar para a DIREITA alem de ~1/3 do ecra = voltar atras (history.back).
     Menos que isso (ou arrastar para a esquerda) -> volta ao lugar.
   - Ao rolar: cada secao / cartao aparece a deslizar da esquerda para a direita.
   Ignora scroll vertical, carrosseis horizontais, campos de formulario,
   links externos / _blank / downloads / mailto / tel / ancoras da mesma pagina.
   Respeita prefers-reduced-motion. Sem JS: navegacao 100% normal, nada escondido.
   Excluir um link:  data-no-transition   |  Excluir zona do arraste: data-no-swipe
   Forcar reveal num elemento:  data-reveal */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DUR = 420;
  var EASE = 'cubic-bezier(.4, 0, .2, 1)';
  var navigating = false;

  function cleanup() {
    var b = document.body;
    b.classList.remove('vlt-pt-leave', 'vlt-pt-drag');
    b.style.transition = '';
    b.style.transform = '';
  }

  function slideInFromLeft() {
    var b = document.body;
    b.classList.add('vlt-pt-drag');
    b.style.transition = 'none';
    b.style.transform = 'translateX(-100%)';
    void b.offsetWidth; // reflow
    b.style.transition = 'transform ' + DUR + 'ms ' + EASE;
    b.style.transform = 'translateX(0)';
    setTimeout(function () { cleanup(); }, DUR + 60);
  }

  window.addEventListener('pageshow', function (e) {
    navigating = false;
    cleanup();
    if (e.persisted) {
      try {
        var v = sessionStorage.getItem('vlt-nav-back');
        if (v) {
          sessionStorage.removeItem('vlt-nav-back');
          if (Date.now() - (+v) < 2000) slideInFromLeft();
        }
      } catch (err) {}
    }
  });

  /* ---------------- clique em links ---------------- */
  document.addEventListener('click', function (e) {
    if (navigating || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (a.target && a.target !== '' && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    if ((a.getAttribute('rel') || '').indexOf('external') !== -1) return;
    if (a.hasAttribute('data-no-transition')) return;

    var raw = a.getAttribute('href') || '';
    if (/^(mailto:|tel:|javascript:)/i.test(raw)) return;

    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) {
      if (url.hash || url.href === location.href) return;
    }

    e.preventDefault();
    navigating = true;
    document.body.classList.add('vlt-pt-leave');
    var done = false;
    var go = function () { if (done) return; done = true; window.location.href = url.href; };
    document.body.addEventListener('animationend', go, { once: true });
    setTimeout(go, DUR);
  }, true);

  /* ---------------- revelar ao rolar (slide da esquerda para a direita) ---------------- */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var SEL = '.vlt-section-head,.vlt-about-copy,.vlt-about-stats,.vlt-cta-copy,' +
      '.vlt-service-card,.vlt-stat-card,.vlt-portfolio-item,.vlt-process-step,.vlt-test-card,' +
      '.vlt-services-note,.vlt-basic-page,.vlt-page-content,.vlt-blog-item,.vlt-product-card,[data-reveal]';

    function start() {
      var all = [].slice.call(document.querySelectorAll(SEL));
      if (!all.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;

      var io = new IntersectionObserver(function (entries) {
        var shown = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.style.transitionDelay = (shown * 55) + 'ms';
          en.target.classList.add('vlt-in');
          io.unobserve(en.target);
          shown++;
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

      all.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh * 0.9) return; // ja visivel -> fica normal, sem animacao
        el.classList.add('vlt-reveal');
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  /* ---------------- arrastar com o dedo (so telemovel) ---------------- */
  if (!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches)) return;

  var startX = 0, startY = 0, curDx = 0, lastX = 0, lastT = 0, vX = 0;
  var decided = false, dragging = false, tId = null;

  function scrollableX(node) {
    while (node && node.nodeType === 1 && node !== document.body) {
      var s = getComputedStyle(node);
      if (/(auto|scroll)/.test(s.overflowX) && node.scrollWidth > node.clientWidth + 2) return true;
      node = node.parentNode;
    }
    return false;
  }
  function blocked(node) {
    return !!(node && node.closest && node.closest('input,textarea,select,button,[contenteditable],[data-no-swipe]'));
  }
  function settle(toZeroMs) {
    var b = document.body;
    b.style.transition = 'transform ' + toZeroMs + 'ms ' + EASE;
    b.style.transform = 'translateX(0)';
    setTimeout(function () { cleanup(); }, toZeroMs + 40);
  }

  document.addEventListener('touchstart', function (e) {
    if (navigating || e.touches.length !== 1) { tId = null; return; }
    var t = e.touches[0];
    if (blocked(t.target) || scrollableX(t.target)) { tId = null; return; }
    startX = lastX = t.clientX;
    startY = t.clientY;
    lastT = e.timeStamp || Date.now();
    curDx = 0; vX = 0; decided = false; dragging = false; tId = t.identifier;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (navigating || tId === null || e.touches.length !== 1) return;
    var t = e.touches[0];
    if (t.identifier !== tId) return;

    var dx = t.clientX - startX;
    var dy = t.clientY - startY;

    if (!decided) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      decided = true;
      dragging = Math.abs(dx) > Math.abs(dy) * 1.3;
      if (!dragging) { tId = null; return; } // intencao vertical -> deixa o scroll
      document.body.classList.add('vlt-pt-drag');
      document.body.style.transition = 'none';
    }

    e.preventDefault(); // segura o scroll enquanto arrasta na horizontal

    var now = e.timeStamp || Date.now();
    var dt = (now - lastT) || 16;
    vX = (t.clientX - lastX) / dt;
    lastX = t.clientX; lastT = now; curDx = dx;

    var vw = window.innerWidth || document.documentElement.clientWidth;
    var shown = dx;
    if (dx < 0) shown = dx / 3.2;                                   // esquerda: resistencia
    else if (dx > vw * 0.6) shown = vw * 0.6 + (dx - vw * 0.6) / 2.4; // direita: trava perto do fim
    document.body.style.transform = 'translateX(' + shown + 'px)';
  }, { passive: false });

  document.addEventListener('touchend', function () {
    if (tId === null) return;
    tId = null;
    if (!dragging) { decided = false; return; }
    dragging = false; decided = false;

    var vw = window.innerWidth || document.documentElement.clientWidth;
    var commit = (curDx > vw * 0.33 || (curDx > 60 && vX > 0.35)) && history.length > 1;

    if (commit) {
      navigating = true;
      try { sessionStorage.setItem('vlt-nav-back', String(Date.now())); } catch (e) {}
      var b = document.body;
      b.style.transition = 'transform ' + DUR + 'ms ' + EASE;
      b.style.transform = 'translateX(100%)';
      var done = false;
      var go = function () { if (done) return; done = true; history.back(); };
      b.addEventListener('transitionend', go, { once: true });
      setTimeout(go, DUR + 60);
    } else {
      settle(300);
    }
  }, { passive: true });

  document.addEventListener('touchcancel', function () {
    if (tId === null) return;
    tId = null; dragging = false; decided = false;
    settle(220);
  }, { passive: true });
})();
